import axios from 'axios';
import { URL } from '../utils/Constants';
import { weightSlabFilter } from '../utils/ValidRateUtils';

// ===== Action Types ===== //
const FETCH_WEIGHT_SLAB_START = 'weightSlab/FETCH_START';
const FETCH_WEIGHT_SLAB_SUCCESS = 'weightSlab/FETCH_SUCCESS';
const FETCH_WEIGHT_SLAB_FAIL = 'weightSlab/FETCH_FAIL';
const RESET_WEIGHT_SLAB = 'weightSlab/RESET';

// ===== Initial State ===== //
const initialState = {
  options: [],
  allWeightSlab: [],
  isLoading: false,
  error: null
};

// ===== Reducer ===== //
export default function weightSlabReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_WEIGHT_SLAB_START:
      return { ...state, isLoading: true, error: null };

    case FETCH_WEIGHT_SLAB_SUCCESS:
      return {
        ...state,
        isLoading: false,
        options: action.payload.map((weightSlab) => ({
          value: weightSlabFilter(
            weightSlab.min,
            weightSlab.measurementIn,
            weightSlab.max,
            weightSlab
          ),
          label: weightSlab.name,
          id: weightSlab.id
        })),
        allWeightSlab: action.payload
      };

    case FETCH_WEIGHT_SLAB_FAIL:
      return { ...state, isLoading: false, error: action.payload, options: [] };

    case RESET_WEIGHT_SLAB:
      return { ...state, options: [], error: null };

    default:
      return state;
  }
}

// ===== Action Creators ===== //
export const fetchWeightSlab = ({ isAir, containerSize }) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_WEIGHT_SLAB_START });

    try {
      let url = `${URL.getWeightSlabData}/${isAir}`;
      if (isAir === 'sea' && containerSize?.id) {
        url = `${URL.getWeightSlabData}/sea/${containerSize.id}`;
      }

      const response = await axios.get(url);
      if (!response.data.success) {
        throw new Error('Failed to fetch weight slab data');
      }

      dispatch({
        type: FETCH_WEIGHT_SLAB_SUCCESS,
        payload: response.data.data.items
      });
    } catch (err) {
      dispatch({
        type: FETCH_WEIGHT_SLAB_FAIL,
        payload: err.message
      });
    }
  };
};

export const resetWeightSlab = () => ({ type: RESET_WEIGHT_SLAB });

// ===== Selectors ===== //
export const selectWeightSlabOptions = (state) => state.weightSlab.options;
export const selectAllWeightSlab = (state) => state.weightSlab.allWeightSlab;
export const selectWeightSlabLoading = (state) => state.weightSlab.isLoading;
export const selectWeightSlabError = (state) => state.weightSlab.error;
